// extracted by mini-css-extract-plugin
export var editButton = "detailsPage-module--edit-button--649a6";
export var pageAdditionalInfos = "detailsPage-module--page-additional-infos--6c910";
export var pageBody = "detailsPage-module--page-body--8aee9";
export var pageFooter = "detailsPage-module--page-footer--1704d";
export var pageFooterBack = "detailsPage-module--page-footer-back--08512";
export var pageIntro = "detailsPage-module--page-intro--d4e6f";
export var pageIntroContainer = "detailsPage-module--page-intro-container--abc41";
export var pageIntroImg = "detailsPage-module--page-intro-img--80c55";
export var pageIntroImgFull = "detailsPage-module--page-intro-img-full--7584c";
export var pageIntroTaxoContainer = "detailsPage-module--page-intro-taxo-container--18edc";
export var pageIntroTitle = "detailsPage-module--page-intro-title--1da06";
export var pageTaxo = "detailsPage-module--page-taxo--1293a";